import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import { InputAdornment, TextField, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "underscore";
import withProfileRedirect from "../../containers/App/withProfileRedirect";
import { setBlockRequest } from "../../globalRedux/actions";
import { getWithdrawalBankList, setIsLoading } from "../redux/action";
import {
  CATEGORY_SAVING,
  DASHBOARD,
  GOALDETAILS,
  GOAL_CREATION,
} from "../redux/constant";
import { resetCount } from "./redux/saga";

import {
  Alert,
  AlertAccount,
  AlertInfo,
  CustomButton,
  CustomInput,
  DefaultLoader,
  Dropdown,
  StepLabel,
} from "../../components";
import NumberFormatCustom from "../../components/NumberFormatCustom";
import { dataLayerGTM } from "../../utils/functions/dataLayerGTM";
import { ordinal } from "../../utils/functions/ordinal";
import { useEcddChecking } from "../../utils/hooks";
import {
  clearErrorRsp,
  getRSPMinAmount,
  setAutoDeposit,
  setDisableRSP,
  setEditRSP,
  setUpLoadingRSP,
} from "./redux/action";
import styles from "./styles";
import "./styles.css";

function generateDates() {
  const arr = [];

  for (let i = 1; i < 32; i++) {
    arr.push(i);
  }
  return arr;
}

// fnz side no longer needed, we temporary hardcoded this instead
const BANK_ACCOUNT_NUMBER = "0123456789";

// this tuple is used to block user update rsp
const notAllowedEnroll = ["Closed", "Frozen", "Closing", "Suspended"];

const liveAgentWhatsappNumber =
    process.env.REACT_APP_LIVE_AGENT_WHATSAPP_NUMBER?.trim();

const liveAgentWhatsappNumberException1 =
    process.env.REACT_APP_LIVE_AGENT_WHATSAPP_NUMBER_EXCEPTION_1?.trim();

const AutoDeposit = props => {
  const {
    loading,
    withdrawalBankList,
    setDisableRSP,
    history,
    match: { params },
    setAutoDeposit,
    savingGoalDetails,
    loadingAutoDeposit,
    errorRSP,
    clearErrorRsp,
    generalSavingDetails,
    savingType,
    setEditRSP,
    location,
    setUpLoadingRSP,
    rspDetail,
    backPayloadRsp,
    subAccountDetail,
    getRSPMinAmount,
    rspMinAmount,
    rspMinAmountLoading,
    loadingRspDetail,
    profile,
    ecddStatus,
    loadingWithdrawalBankList,
    getWithdrawalBankList,
  } = props;

  const from = params.from;
  const setup = params.setup;

  const [fields, setFields] = useState({
    isRSPEnable: "Enable",
    totalAmount: "",
    preferredDate: "",
    bankAccountNo: "",
    bank: {
      bankCd: "",
      bankName: "",
      accountNumber: "",
    },
  });
  const [isSubmitDisabled, setIsSumittedDisabled] = useState(false);

  const initialFieldsValue = useRef({});

  const isAutoEnable = fields.isRSPEnable === "Enable";
  const isAutoDisable = fields.isRSPEnable === "Disable";
  const isEditingRsp = setup === "edit" && Object.values(rspDetail).length > 0;

  const updateRspStatus =
    rspDetail &&
    typeof rspDetail === "object" &&
    "rspStatus" in rspDetail &&
    (rspDetail.rspStatus === "5" || rspDetail.rspStatus === "12");

  const isCanceledRsp = fields.isRSPEnable === "Disable" && updateRspStatus;

  const [errorRspUi, setErrorRspUi] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [backPayload, setBackPayload] = useState({});
  const [amountHelper, setAmounthelper] = useState({
    text: "This field is required",
    minValue: rspMinAmount.value,
  });
  const { handleCheckEcdd, status, onResetStatus } = useEcddChecking({
    ecddStatus,
    aml: profile &&
      profile.amlHistory.length > 0 &&
      typeof profile.amlHistory[0] === "object" && {
        result: profile.amlHistory[0].amlResult,
        status: profile.amlHistory[0].amlSts,
      },
    shouldNotPromptOnEffect: true,
  });

  const [fieldError, setFieldError] = useState({
    amount: false,
    dateOfMonth: false,
    bankName: false,
    bankAccountNo: false,
  });
  const [isBankListOpen, setBankListOpen] = useState(false);
  const [subaccountStatus, setSubaccountStatus] = useState({
    allow: true,
    open: false,
  });
  const [headAccountStsAlert, setHeadAccountStsAlert] = useState({
    alert: false,
    status: "Active",
  });
  const [isDateListOpen, setDateListOpen] = useState(false);

  const headAccountCheck = () => {
    const { headAccount } = profile;

    if (headAccount?.sts) {
      const isSuspended = headAccount.sts === "Suspended";
      const isDeactivated = notAllowedEnroll.includes(headAccount.sts);

      if (isSuspended || isDeactivated) {
        setHeadAccountStsAlert(prev => ({
          ...prev,
          alert: true,
          status: isSuspended ? "Suspended" : "Deactived",
        }));

        return false;
      }
    }

    return true;
  };

  const handleOpenPDF = pdfUrl => {
    window.my.showLoading();
    window.my.postMessage({
      api: "downloadFile",
      pdf: pdfUrl,
      event: "openPdf",
    });
  };

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === "isRSPEnable") {
      dataLayerGTM("click_tag", "Click", "Button", `Click ${value} button`);
    }

    // revert to initial value when user try to deactivated active rsp
    if (value === "Disable" && updateRspStatus) {
      const existBank = getBank(rspDetail.bankCd);
      setFields({
        bank: {
          bankCd: existBank.bankCdOrigin,
          bankName: existBank.name,
        },
        totalAmount: rspDetail.amount || "",
        bankAccountNo: rspDetail.bankAccountNo,
        preferredDate: rspDetail.dateOfMonth
          ? parseInt(rspDetail.dateOfMonth)
          : "",
        isRSPEnable: value,
      });
    } else {
      setFields(prevFields => ({ ...prevFields, [name]: value }));
    }

    if (value.length > 0) {
      setFieldError({ ...fieldError, bankAccountNo: false });
    }
    setFieldError({
      amount: false,
      dateOfMonth: false,
      bankName: false,
      bankAccountNo: false,
    });
  };

  const handleAmountChange = ({ target: { value } }) => {
    setFields(prevFields => ({ ...prevFields, totalAmount: value }));

    if (value >= parseFloat(amountHelper.minValue)) {
      setFieldError({ ...fieldError, amount: false });
    }
  };

  const getBank = bankCd => {
    const existBank = withdrawalBankList.find(
      item => item.bankCdOrigin === bankCd
    );

    return existBank;
  };

  useEffect(() => {
    setAmounthelper({ ...amountHelper, minValue: rspMinAmount.value });
  }, [rspMinAmount]);

  useEffect(() => {
    if (!subAccountDetail) return;

    // if sts is in `notAlowedEnroll` then block the user

    if (notAllowedEnroll.includes(subAccountDetail?.sts)) {
      setSubaccountStatus({ open: false, allow: false });
    }
  }, [subAccountDetail, rspDetail]);

  useEffect(() => {
    getRSPMinAmount();
    getWithdrawalBankList({ rsp: true });
  }, []);

  useEffect(() => {
    setUpLoadingRSP(false);

    if (isEditingRsp) {
      initialFieldsValue.current = {
        totalAmount: rspDetail.amount || "",
        bankCd: rspDetail.bankCd,
        bankAccountNo: rspDetail.bankAccountNo,
        preferredDate: rspDetail.dateOfMonth
          ? parseInt(rspDetail.dateOfMonth)
          : "",
      };
    }

    if (location.state) {
      setBackPayload({
        cifPlanId: location.state.cifPlanId,
        productId: location.state.productId,
      });
    }
  }, [rspDetail]);

  useEffect(() => {
    if (setup === "setupRSP") {
      setFields(prevFields => ({
        ...prevFields,
        totalAmount: "",
      }));

      if (subAccountDetail?.sts === "Closing") {
        setFields(prevFields => ({
          ...prevFields,
          isRSPEnable: "Disable",
        }));
      }

      if (
        typeof rspDetail === "object" &&
        Object.entries(rspDetail).length > 0
      ) {
        setFields(prevFields => ({
          ...prevFields,
          bankAccountNo:
            rspDetail.lastBankAccountNo || rspDetail.bankAccountNo || "",
        }));

        if (Array.isArray(withdrawalBankList)) {
          const existBank = getBank(
            rspDetail.lastBankCd || rspDetail.bankCd || ""
          );
          if (existBank) {
            setFields(prevFields => ({
              ...prevFields,
              bank: {
                bankCd: existBank.bankCdOrigin,
                bankName: existBank.name,
              },
            }));
          }
        }
      }
    } else if (isEditingRsp) {
      setIsSumittedDisabled(true);
      let { dateOfMonth } = rspDetail;
      const dateNew = new Date();

      const isSubaccountClosing = subAccountDetail?.sts === "Closing";

      if (isSubaccountClosing) setIsSumittedDisabled(true);

      if (
        rspDetail.rspStatus === "0" ||
        rspDetail.rspStatus === "26" ||
        rspDetail.rspStatus === "21" ||
        isSubaccountClosing
      ) {
        setFields(prevFields => ({
          ...prevFields,
          isRSPEnable: "Disable",
        }));
      } else {
        setFields(prevFields => ({
          ...prevFields,
          isRSPEnable: "Enable",
        }));
      }

      if (dateOfMonth) {
        dateNew.setDate(dateOfMonth);
        setFields(prevFields => ({
          ...prevFields,
          preferredDate: dateNew.getDate(),
        }));
      }
      setFields(prevFields => ({
        ...prevFields,
        totalAmount: rspDetail.amount || "",
        bankAccountNo: rspDetail.bankAccountNo,
      }));
      if (Array.isArray(withdrawalBankList)) {
        const existBank = getBank(rspDetail.bankCd);
        if (existBank) {
          setFields(prevFields => ({
            ...prevFields,
            bank: {
              bankCd: existBank.bankCdOrigin,
              bankName: existBank.name,
            },
          }));
        }
      }
    } else {
      setFields(prevFields => ({ ...prevFields, totalAmount: "" }));
    }
  }, [
    savingType,
    savingGoalDetails,
    withdrawalBankList,
    rspDetail,
    subAccountDetail,
  ]);

  const checkSubmited = (initial, edited) => {
    let rspDetailRef;
    if (!rspDetail) {
      rspDetailRef = {};
    } else {
      rspDetailRef = rspDetail;
    }
    let { rspStatus = "" } = rspDetailRef;
    switch (true) {
      case (rspStatus === "0" || rspStatus === "21" || rspStatus === "26") &&
        fields.isRSPEnable === "Disable":
        setIsSumittedDisabled(true);
        return;
      case (rspStatus === "0" || rspStatus === "21" || rspStatus === "26") &&
        fields.isRSPEnable === "Enable":
        setIsSumittedDisabled(false);
        return;
      case (rspStatus === "5" ||
        rspStatus === "16" ||
        rspStatus === "11" ||
        rspStatus === "12") &&
        fields.isRSPEnable === "Enable" &&
        initial === edited:
        setIsSumittedDisabled(true);
        return;
      default:
        setIsSumittedDisabled(false);
        return;
    }
  };

  useEffect(() => {
    if (
      isEditingRsp &&
      typeof rspDetail === "object" &&
      Object.entries(rspDetail).length > 0
    ) {
      const {
        isRSPEnable,
        preferredDate: editedPreferredDate,
        ...rest
      } = fields;

      // 1. allow user if they have status rsp of 5 | 12 and choose the radio button to disabled (deactive)
      // 2. allow user if they have active subaccount and status rsp of 0 | 21 | 26 and choose the radio button to enable (reactive)
      if (
        (updateRspStatus && isAutoDisable) ||
        (subAccountDetail?.sts === "Active" &&
          ["0", "21", "26"].includes(rspDetail.rspStatus) &&
          isAutoEnable)
      ) {
        setSubaccountStatus({ allow: true, open: false });
      } else if (notAllowedEnroll.includes(subAccountDetail?.sts)) {
        setSubaccountStatus({ allow: false, open: false });
      }

      const {
        preferredDate: initialPreferredDate,
        ...initialRest
      } = initialFieldsValue.current;

      //! order of property is important

      const initial = JSON.stringify({
        totalAmount: initialRest.totalAmount.toString(),
        bankCd: initialRest.bankCd,
        // bankAccountNo: initialRest.bankAccountNo,
        preferredDate: initialPreferredDate,
      });

      const edited = JSON.stringify({
        totalAmount: rest.totalAmount.toString(),
        bankCd: fields.bank.bankCd,
        //  bankAccountNo: rest.bankAccountNo,
        preferredDate: editedPreferredDate,
      });

      checkSubmited(initial, edited);
    }
  }, [fields, rspDetail, subAccountDetail]);

  const longText = (
    <>
      (a) Understand and agree to the{" "}
      <span
        style={{ color: "#0076cf" }}
        onClick={() =>
          handleOpenPDF(
            "https://www.principal.com.my/sites/default/files/pdf-uploads/FPX%20Direct%20Debit%20Service%20Terms%20and%20Conditions.pdf"
          )
        }
      >
        Terms & Conditions
      </span>{" "}
      of Direct Debit service.
      <br />
      (b) To be bound by{" "}
      <span
        style={{ color: "#0076cf" }}
        onClick={() =>
          handleOpenPDF(
            "https://www.principal.com.my/sites/default/files/pdf-uploads/Principal%20Mini%20Program%20%28IMMF%20Class%20D%29%20Terms%20and%20Conditions.pdf"
          )
        }
      >
        Principal’s Terms & Conditions.
      </span>{" "}
      <br />
      (c) The fees charges will incur directly and indirectly when investing in
      the relevant fund.
    </>
  );
  const shortText = (
    <>
      (a) Understand and agree to the{" "}
      <span
        style={{ color: "#0076cf" }}
        onClick={() =>
          handleOpenPDF(
            "https://www.principal.com.my/sites/default/files/pdf-uploads/FPX%20Direct%20Debit%20Service%20Terms%20and%20Conditions.pdf"
          )
        }
      >
        terms and conditions{" "}
      </span>
      of Direct Debit service....
    </>
  );

  const validationRSPfield = val => {
    const tempError = {
      amount: false,
      dateOfMonth: false,
      bankName: false,
      // bankAccountNo: false
    };

    let requireField = {
      amount: val.amount,
      dateOfMonth: val.dateOfMonth,
      bankName: val.bankCd,
      bankAccountNo: val.bankAccountNo,
    };

    for (const key in requireField) {
      if (requireField[key].length === 0) {
        tempError[key] = true;
      }
    }

    if (val.amount < parseFloat(amountHelper.minValue) || val.amount > 30000) {
      tempError.amount = true;
    }

    if (tempError.amount) {
      if (val.amount < parseFloat(amountHelper.minValue)) {
        setAmounthelper({
          ...amountHelper,
          text: `Minimum RM ${parseFloat(amountHelper.minValue).toFixed(2) ||
            "10.00"} `,
        });
      } else if (val.amount > 30000) {
        setAmounthelper({
          ...amountHelper,
          text:
            "The maximum Cash In amount per transaction is RM30,000. You may proceed with your additional Cash In into multiple transactions.",
        });
      } else {
        setAmounthelper({ ...amountHelper, text: "This field is required" });
      }
    }
    if (!isAutoDisable) {
      setFieldError(prevState => ({
        ...prevState,
        amount: tempError.amount,
        dateOfMonth: tempError.dateOfMonth,
        bankName: tempError.bankName,
        bankAccountNo: tempError.bankAccountNo,
      }));
    }

    for (const key in tempError) {
      if (tempError[key] === true) {
        return false;
      }
    }
    if (
      val.cifPlanId.length === 0 ||
      !val.cifPlanId ||
      val.cifPlanId === null
    ) {
      setErrorRspUi(true);
      return false;
    }

    return true;
  };

  const handleSubmit = () => {
    const goalDetail =
      savingType === CATEGORY_SAVING ? savingGoalDetails : generalSavingDetails;
    const payload = {
      cifPlanId: goalDetail.id,
      amount: fields.totalAmount.toString(),
      dateOfMonth: String(fields.preferredDate),
      bankCd: fields.bank.bankCd,
      bankAccountNo: BANK_ACCOUNT_NUMBER,
      currency: "MYR",
    };

    let validation = validationRSPfield(payload);
    if (!validation && !isAutoDisable) {
      return;
    }

    if (!subaccountStatus.allow) {
      setSubaccountStatus(prev => ({ allow: prev.allow, open: true }));
      return;
    }

    if (isAutoDisable) {
      setDisableRSP(payload.cifPlanId, () => {
        history.push(
          `/make-deposit/${from}/success/auto-deposit/${setup}/success-cancel`
        );
      });
    } else {
      if (setup === "edit") {
        let { rspStatus = "" } = rspDetail;
        const { totalAmount, preferredDate } = initialFieldsValue.current;
        if (rspStatus === "0" || rspStatus === "21" || rspStatus === "26") {
          handleSubmitSucceess(payload, "setup");
        } else if (
          fields.preferredDate !== preferredDate ||
          fields.totalAmount < totalAmount
        ) {
          handleSubmitSucceess(payload, "edit go to dashboard");
        } else {
          handleSubmitSucceess(payload, "edit go to fpx");
        }

        return;
      }
      handleSubmitSucceess(payload, "setup");
    }
  };

  const handleSubmitSucceess = (payload, action) => {
    if (!headAccountCheck()) {
      return;
    }
    if (action === "setup") {
      setAutoDeposit(payload);
    }

    if (action === "edit go to fpx") {
      setEditRSP(payload);
    }
    if (action === "edit go to dashboard") {
      setEditRSP(payload, () => {
        history.push(`/make-deposit/${from}/success/rsp/success`);
      });
    }
  };

  const handleBack = () => {
    resetCount();
    if (from === DASHBOARD) {
      history.push(`/dashboard`);
      return;
    }

    if (Object.values(backPayloadRsp).length > 0) {
      history.push(`/make-deposit/${GOAL_CREATION}`, backPayloadRsp);
    } else {
      history.back();
    }
  };

  if (
    loading ||
    loadingAutoDeposit ||
    rspMinAmountLoading ||
    loadingRspDetail ||
    loadingWithdrawalBankList
  ) {
    return <DefaultLoader />;
  }

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <Alert
        title="Account Verification"
        description="Thank you for submitting your information. We need to perform further verification to activate your account."
        isOpen={status === "pending"}
        isCS="https://principal.com.my"
        isCancel={false}
        btnTxt="Chat with us on WhatsApp"
        handleAction={() => {
          onResetStatus();
          window.my.call("openAppLink", {
            url: `https://wa.me/${liveAgentWhatsappNumberException1}`,
          });
        }}
        handleCancel={onResetStatus}
      />
      <Alert
        title="Your account is deactivated"
        description="So sorry, your account is deactivated. We need to perform a verification to activate your account."
        isOpen={status === "rejected"}
        isCS="https://principal.com.my"
        isCancel={false}
        btnTxt="Chat with us on WhatsApp"
        handleAction={() => {
          onResetStatus();
          window.my.call("openAppLink", {
            url: `https://wa.me/${liveAgentWhatsappNumberException1}`,
          });
        }}
        handleCancel={onResetStatus}
      />
      <AlertInfo
        description="We are facing some technical issues, and we are working very hard to resolve the issue."
        isOpen={errorRSP || errorRspUi}
        isTimeout={true}
        handleAction={() => {
          clearErrorRsp();
          resetCount();
          setErrorRspUi(false);
          if (from === GOAL_CREATION) {
            history.push(`/make-deposit/${GOAL_CREATION}`, backPayloadRsp);
          } else if (from === GOALDETAILS) {
            history.go(-2);
          } else {
            history.back();
          }
        }}
      />

      <AlertAccount
        title={`Account ${
          headAccountStsAlert.status === "Suspended" ? "Suspended" : "Inactive"
        }`}
        firstText={
          headAccountStsAlert.status === "Suspended"
            ? "Your account is currently suspended, we are unable to process your Cash In request however, you can still proceed with Cash Out."
            : "Your account is currently inactive, we're sorry for the inconvenience."
        }
        secondText={
          <span>
            For assistance, kindly contact our{" "}
            <span
              onClick={() => {
                setHeadAccountStsAlert(prev => ({
                  ...prev,
                  alert: false,
                }));

                window.my.call("openAppLink", {
                  url: `https://wa.me/${liveAgentWhatsappNumberException1}`,
                });
              }}
              style={{ color: "#1278CC" }}
            >
              Customer Care Centre.
            </span>
          </span>
        }
        isOpen={headAccountStsAlert.alert}
        handleClose={() => {
          setHeadAccountStsAlert(prev => ({
            ...prev,
            alert: false,
          }));
        }}
      />

      <AlertAccount
        title={`Account ${
          subAccountDetail?.sts === "Suspended" ? "Suspended" : "Inactive"
        }`}
        firstText={
          subAccountDetail?.sts === "Suspended"
            ? "Your account is currently suspended, we are unable to process your Cash In request however, you can still proceed with Cash Out."
            : "Your account is currently inactive, we're sorry for the inconvenience."
        }
        secondText={
          <span>
            For assistance, kindly contact our{" "}
            <span
              onClick={() => {
                setSubaccountStatus(prev => ({
                  allow: prev.allow,
                  open: false,
                }));

                window.my.call("openAppLink", {
                  url: `https://wa.me/${liveAgentWhatsappNumberException1}`,
                });
              }}
              style={{ color: "#1278CC" }}
            >
              Customer Care Centre.
            </span>
          </span>
        }
        isOpen={subaccountStatus.open}
        handleClose={() => {
          const subaccountStatusThatShouldStaysOnRSP = [
            "Frozen",
            "Closing",
            "Closed",
            "Suspended",
          ].includes(subAccountDetail?.sts);

          setSubaccountStatus(prev => ({ allow: prev.allow, open: false }));
          if (updateRspStatus) {
            if (subaccountStatusThatShouldStaysOnRSP) {
              return;
            }
          }

          if (!savingGoalDetails.id) {
            history.back();
          } else {
            history.push(`/goal-list/${savingGoalDetails.id}`);
          }
        }}
      />

      <Dropdown
        bottomHeight={({ maxHeight }) => maxHeight * 0.6}
        isOpen={isBankListOpen}
        handleDismiss={() => setBankListOpen(false)}
      >
        <div style={{ padding: "16px 16px 0" }}>
          <Typography
            color="secondary"
            style={{ ...styles.baseFont, ...styles.dropdownTitle }}
          >
            Bank list
          </Typography>
          {withdrawalBankList.length > 0 &&
            withdrawalBankList.map((bankItem, index) => {
              return (
                <div
                  key={index}
                  onClick={() => {
                    setFields(prevFields => ({
                      ...prevFields,
                      bank: {
                        bankCd: bankItem.bankCdOrigin,
                        bankName: bankItem.name,
                      },
                    }));
                    setFieldError({ ...fieldError, bankName: false });
                    setBankListOpen(false);
                  }}
                  style={{
                    ...styles.row,
                    justifyContent: "space-between",
                    margin: "32px 0",
                  }}
                >
                  <Typography
                    color="textPrimary"
                    style={{ ...styles.baseFont, fontWeight: "700" }}
                  >
                    {bankItem.name}
                  </Typography>
                  {fields.bank.bankName === bankItem.name && (
                    <DoneOutlinedIcon
                      sx={{ cursor: "pointer", color: "#0091DA", fontSize: 24 }}
                    />
                  )}
                </div>
              );
            })}
        </div>
      </Dropdown>

      <Dropdown
        bottomHeight={({ maxHeight }) => maxHeight * 0.6}
        isOpen={isDateListOpen}
        handleDismiss={() => setDateListOpen(false)}
      >
        <div style={{ padding: "16px 16px 0" }}>
          <Typography
            color="secondary"
            style={{ ...styles.baseFont, ...styles.dropdownTitle }}
          >
            Date of month
          </Typography>
          {generateDates().map(item => {
            return (
              <div
                key={item}
                onClick={() => {
                  setFields(prevFields => ({
                    ...prevFields,
                    preferredDate: item,
                  }));
                  setFieldError({ ...fieldError, dateOfMonth: false });
                  setDateListOpen(false);
                }}
                style={{
                  ...styles.row,
                  justifyContent: "space-between",
                  margin: "32px 0",
                }}
              >
                <Typography
                  color="textPrimary"
                  style={{ ...styles.baseFont, fontWeight: "700" }}
                >
                  {ordinal(item)} of each month
                </Typography>
                {fields.preferredDate === item && (
                  <DoneOutlinedIcon
                    sx={{ cursor: "pointer", color: "#0091DA", fontSize: 24 }}
                  />
                )}
              </div>
            );
          })}
        </div>
      </Dropdown>

      <div style={styles.container}>
        <StepLabel
          title="Insert Bank Information"
          containerStyles={{ margin: "16px 16px 22px" }}
          onClick={handleBack}
        />

        <form style={{ margin: "0 16px" }}>
          <CustomInput
            label="Enable monthly auto Cash In"
            name="isRSPEnable"
            isRadio={true}
            isEdit={true}
            rspDisable={
              from === GOAL_CREATION || setup === "setupRSP" ? true : false
            }
            value={fields.isRSPEnable}
            onChange={handleChange}
          />
          <Typography
            sx={{
              ...styles.label,
              color: isAutoDisable && "#9D9EA4",
            }}
          >
            Please enter an amount
          </Typography>
          <TextField
            variant="outlined"
            name="totalAmount"
            placeholder={`0 (Enter an amount, min RM${amountHelper.minValue})`}
            style={{ width: "100%", marginBottom: "14px" }}
            value={fields.totalAmount}
            error={fieldError.amount}
            helperText={fieldError.amount && amountHelper.text}
            FormHelperTextProps={{
              style: {
                margin: "8px 0 0 0",
                fontFamily: "FSElliotPro",
                fontSize: "14px",
                fontWeight: "normal",
                lineHeight: 1.43,
                color: "#be0712",
              },
            }}
            onChange={handleAmountChange}
            disabled={isAutoDisable}
            inputProps={{
              style: {
                padding: "12px 16px 12px 0px",
              },
              className: { ...styles.baseFont },
              maxLength: 16, // only work for type other than number
            }}
            // eslint-disable-next-line react/jsx-no-duplicate-props
            InputProps={{
              inputComponent: NumberFormatCustom,
              style: { paddingLeft: "16px" },
              startAdornment: (
                <InputAdornment position="start">
                  <Typography
                    color="textPrimary"
                    // className={{ ...styles.prefix }}
                    sx={{
                      fontWeight: "700",
                      color: isAutoDisable && "#9D9EA4",
                    }}
                  >
                    RM
                  </Typography>
                </InputAdornment>
              ),
            }}
          />
          <Typography
            style={{
              ...styles.baseFont,
              fontSize: "14px",
              lineHeight: 1.57,
              fontWeight: "700",
              marginBottom: "16px",
            }}
          >
            The auto Cash In will be subject to applicable sales charges and SST
            (if any).
          </Typography>
          <CustomInput
            label="Your preferred auto Cash In date"
            disabledRSPInput={isAutoDisable}
            name="dateOfMonth"
            placeholder="Auto Cash In date"
            value={
              fields.preferredDate
                ? `${ordinal(fields.preferredDate)} of each month`
                : ""
            }
            isEdit
            isDropdown
            isDate
            error={fieldError.dateOfMonth}
            onClick={() => {
              isAutoEnable && setDateListOpen(true);
            }}
            disabled={isAutoDisable}
          />
          <CustomInput
            label="Your preferred bank"
            disabledRSPInput={isAutoDisable}
            name="bankName"
            placeholder="Select a bank"
            value={fields.bank.bankName}
            isEdit={true}
            isDropdown={true}
            error={fieldError.bankName}
            onClick={() => {
              isAutoEnable && setBankListOpen(true);
            }}
            disabled={isAutoDisable}
          />
          {/*
            READ THE TOP OF THE FILE
          */}
          {/* <CustomInput
            label="Bank Account Number"
            disabledRSPInput={isAutoDisable}
            name="bankAccountNo"
            value={fields.bankAccountNo}
            isEdit={true}
            onChange={handleChange}
            type="number"
            error={fieldError.bankAccountNo}
            disabled={isAutoDisable}
            placeholder="1234567890"
          /> */}
          <Typography
            style={{
              ...styles.baseFont,
              fontSize: "14px",
              lineHeight: 1.57,
              fontWeight: "700",
              marginBottom: "16px",
            }}
          >
            Please note: RM1 will be charged to verify your account and refunded
            in accordance with our Terms & Conditions.
          </Typography>
        </form>

        {/* term conditions */}
        <div
          style={{
            position: showMore && "sticky",
            bottom: 0,
            width: "100%",
            display: "block",
            marginTop: "auto",
            padding: "16px 16px 24px",
            backgroundColor: "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <Typography
              color="secondary"
              style={{
                ...styles.baseFont,
                fontWeight: "700",
                color: "#616367",
              }}
            >
              By proceeding, I have read, understood and accepted:
            </Typography>
          </div>
          <div style={{ marginBottom: "24px" }}>
            <Typography
              style={{
                ...styles.baseFont,
                fontSize: "14px",
                lineHeight: 1.57,
                color: "#616367",
              }}
            >
              {showMore ? (
                longText
              ) : (
                <>
                  {shortText}

                  <span
                    style={{
                      color: "#0076cf",
                      fontSize: "16px",
                      marginLeft: "4px",
                    }}
                    onClick={() => {
                      dataLayerGTM(
                        "click_tag",
                        "Click",
                        "Button",
                        "Click Show More Button"
                      );

                      setShowMore(true);
                    }}
                  >
                    Show More
                  </span>
                </>
              )}
            </Typography>
            <Typography
              style={{
                ...styles.baseFont,
                lineHeight: 1.25,
                color: "#0076cf",
                marginTop: "8px",
              }}
              onClick={() => setShowMore(!showMore)}
            >
              {showMore && "Show Less"}
            </Typography>
          </div>
          <CustomButton
            disabled={loadingAutoDeposit || isSubmitDisabled ? true : false}
            text="Next"
            variant="contained"
            color="#fff"
            backgroundColor="#1278CC"
            onClick={
              isCanceledRsp
                ? handleSubmit
                : handleCheckEcdd({
                    cb: handleSubmit,
                    ecddExpiredCb: () => history.push("/onBoarding/ecdd/RSP"),
                    gtm: {
                      event: "click_tag",
                      action: "Click",
                      category: "Button",
                      label: "Click Next - Insert Bank Information button",
                    },
                  })
            }
          />
        </div>
      </div>
    </div>
  );
};

const withConnect = connect(
  state => ({
    loading: state.goal.loading,
    ppgToken: state.goal.ppgToken,
    withdrawalBankList: state.goal.withdrawalBankList,
    savingType: state.goal.savingType,
    savingGoalDetails: state.goal.savingGoalDetails,
    generalSavingDetails: state.goal.generalSavingDetails,
    profile: state.goal.profile,
    ecddStatus: state.goal.ecddStatus,
    loadingWithdrawalBankList: state.goal.loadingWithdrawalBankList,

    ...state.autoDepositReducer,
    ...state.goalDetailReducer,
    ...state.commingFromReducer,
  }),
  {
    setDisableRSP,
    setIsLoading,
    setAutoDeposit,
    clearErrorRsp,
    setUpLoadingRSP,
    setEditRSP,
    setBlockRequest,
    getRSPMinAmount,
    getWithdrawalBankList,
  }
);

export default compose(
  withRouter,
  withConnect,
  withProfileRedirect
)(AutoDeposit);
